import noop from 'utils/noop';

export const useFocusEffect = noop;
